export const AUTHORIZE_TIMEOUT_MS = 15000;
export const TENANT_SWITCH_TIMEOUT_MS = 10000;
export const TOKEN_POLL_INTERVAL_MS = 250;
export const TOKEN_EXPIRY_BUFFER_MS = 30000;
export const UNAUTHORIZED_STATUS_CODE = 401;
